// ESM module to register <wl-sub-banner-lists-slider> and initialize Swiper

class WLSubBannerListsSlider extends HTMLElement {
  constructor() {
    super();
    this._swiper = null;
    this._container = null;
  }

  connectedCallback() {
    this._waitForSwiper();
  }

  disconnectedCallback() {
    if (this._swiper) {
      this._swiper.destroy(true, true);
      this._swiper = null;
    }
  }

  _waitForSwiper(maxAttempts = 50, attempt = 0) {
    if (window.Swiper) {
      requestAnimationFrame(() => this._init());
      return;
    }
    if (attempt >= maxAttempts) return;
    setTimeout(() => this._waitForSwiper(maxAttempts, attempt + 1), 100);
  }

  _init() {
    if (!window.Swiper) return;
    this._container = this.querySelector('.wl-sub-banner-lists-swiper');
    if (!this._container) return;

    const paginationEl = this._container.querySelector('.swiper-pagination');

    const options = {
      speed: 500,
      loop: false,
      centeredSlides: false,
      spaceBetween: 10,
      slidesPerView: 3,
      breakpoints: {
        990: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : undefined,
      on: {
        init: () => {
          this._container.classList.add('is-initialized');
        },
      },
    };

    this._swiper = new window.Swiper(this._container, options);
  }
}

if (!customElements.get('wl-sub-banner-lists-slider')) {
  customElements.define('wl-sub-banner-lists-slider', WLSubBannerListsSlider);
}

export default WLSubBannerListsSlider;


